// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';

function findLinks(text) {

    let returnElement;
    const urlRegExp = /\bhttps?:\/\/[^\s]+/gi;
    const emailRegExp = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,18}\b/gi;

    returnElement = text;

    returnElement = returnElement.replace(urlRegExp, m =>
        `<a href="${m.replace('\n', '')}" rel="noopener noreferrer" target="_blank">${m}</a>`);

    returnElement = returnElement.replace(emailRegExp, m =>
        `<a href="mailto:${m.replace('\n', '')}">${m}</a>`);

    return {__html: returnElement};

}

const HtmlText = props =>
    <pre
        className='html-text'

        /* eslint-disable react/no-danger */

        dangerouslySetInnerHTML={findLinks(props.text)}

        /* eslint-enable react/no-danger */

    >
    </pre>;

HtmlText.displayName = 'HtmlText';
HtmlText.propTypes = {
    text: PropTypes.string.isRequired
};

export default HtmlText;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/instructions-panels/html-text.js